import { cadOpType } from "lib/operations/factory";
import { EditDataCommand } from "./edit-base";

export class CubeEditDataCommand extends EditDataCommand {
    protected opType = cadOpType.EDITCUBE;
}